import * as React from 'react'

export interface Props {
  className?: string
  viewBox?: string
  size?: 'x-small' | 'small' | 'medium' | 'large' | 'x-large' | 'big' | 'huge'
  children?: React.ReactNode
}

export class BaseIcon extends React.Component<Props> {
  public defaults = {
    className: 'fill-current ',
    size: 'large',
    viewBox: '0 0 25 25',
  }

  /*constructor (props: Props) {
    super(props)
  }*/

  public getSize (): string {
    let size = ''
    switch (this.props.size) {
      case 'x-small':
        size = 'w-3'
        break
      case 'small':
        size = 'w-4'
        break
      case 'medium':
        size = 'w-6'
        break
      case 'large':
        size = 'w-8'
        break
      case 'x-large':
        size = 'w-8'
        break
      case 'big':
        size = 'w-14'
        break  
      case 'huge':
        size = 'w-16'
        break
      default:
        size = ''
    }

    return size
  }

  public render (): React.ReactNode {

    return(
        this.props.children
    )
  }
}

export default BaseIcon
